const updates = [
  { date: '07-31', text: '《星际穿越2》高清版正式上线，多线路流畅播放', tag: '新片上线' },
  { date: '07-30', text: '日剧《重启人生2》全10集更新完毕，口碑爆棚', tag: '全集更新' },
  { date: '07-29', text: '国产悬疑剧《暗夜追踪者》首播，首日播放量破500万', tag: '热播推荐' },
  { date: '07-28', text: '90影视APP v4.2版本发布，新增智能推荐算法', tag: '版本更新' },
  { date: '07-27', text: '暑期动画专题上线，《哪吒3》《白蛇4》等大作收录', tag: '专题上线' },
  { date: '07-26', text: '平台CDN节点扩容完成，全网播放流畅度提升30%', tag: '系统升级' },
  { date: '07-25', text: '韩剧《黑暗荣耀3》同步韩国播出，中文字幕更新中', tag: '海外同步' },
  { date: '07-24', text: '豆瓣9.0分纪录片《地球脉动4》4K版独家上线', tag: '高分精选' },
  { date: '07-23', text: '美剧《最后生还者2》第一集上线，游戏改编再创经典', tag: '热门新剧' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            更新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            90影视平台最新影视资源上线动态与平台公告速览
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/60 space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[calc(2rem+5px)] top-1 w-2.5 h-2.5 rounded-full bg-accent-500 ring-4 ring-background-100"></div>
                <div className="bg-background-50 rounded-lg border border-background-200/60 p-4">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                    <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full">{item.tag}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}